import React, {Component, Fragment, createRef} from 'react'
import PropTypes from 'prop-types'

import Modal from '@app/components/ui/modals/Modal'
import PasswordsPrintButton from '@app/components/shared/PasswordsPrintButton'
import PasswordsDownloadButton from '@app/components/shared/PasswordsDownloadButton'
import SharePasswordsButton from '@app/components/shared/SharePasswordsButton'

import SVG from 'react-inlinesvg'
import printIcon from '@icons/print/primary'

class ShareLoginsButton extends Component {
  constructor (props) {
    super(props)

    this.modal = createRef(null)
    this.handleClick = this.handleClick.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.state = { modalOpened: false }
  }

  handleClick(e) {
    this.setState(() => { return {...this.state, modalOpened: true} })
    this.modal.current.open()
    return false
  }

  handleClose(e) {
    this.setState(() => { return {...this.state, modalOpened: false} })
    this.modal.current.close()
    return false
  }

  renderContent() {
    const { modalOpened } = this.state;
    if (!modalOpened) { return null; }

    const { students, filename } = this.props;

    return (
      <Fragment>
        <h1 className="modal__title">
          { I18n.t('registration.completed.teacher.title') }
        </h1>

        <div className="w-flex-layout w-flex-layout--columns w-flex-layout--ai-left">
          <SharePasswordsButton students={students} callback={this.handleClose} />
          <PasswordsDownloadButton filename={filename} students={students} />
          <PasswordsPrintButton
            students={students}
            className="link link--icon-left f--upper">

            <SVG src={printIcon} />
            { I18n.t('groups.group_header.print_logins_and_passwords') }
          </PasswordsPrintButton>
        </div>

        <div className="w-flex-layout w-flex-layout--columns mt-gutter-l">
          <a href="javascript:void(0)" onClick={this.handleClose} className="btn btn--light-blue f--upper">
            { I18n.t('browser_not_supported.close') }
          </a>
        </div>
      </Fragment>
    )
  }

  render() {
    const { students } = this.props;

    return (
      <Fragment>
        <button
          disabled={students.length === 0}
          onClick={this.handleClick}
          className="btn f--upper"
        >
          { I18n.t('teachers.show.share_logins') }
        </button>
        <Modal ref={this.modal} className="modal--md">
          { this.renderContent() }
        </Modal>
      </Fragment>
    )
  }
}

ShareLoginsButton.propTypes = {
  students: PropTypes.array.isRequired,
  filename: PropTypes.string.isRequired
}

export default ShareLoginsButton
